module.exports = __webpack_public_path__ + "static/media/first-website.aa78cb1f.jpg";